<div class="mapContent"> 
    <app-source-map></app-source-map>
</div>

<div class="planfields">
    <h2>اختيار المخطط</h2>
      <div class="input-field">
        <label for="baladeya"> البلدية </label>
        <select id="baladeya" (change)="onBaladeyaNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of baladeyaNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>

      <div class="input-field">
        <label for="neigh"> اسم الحي </label>
        <select id="neigh" (change)="onNeighNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of neighNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>

      <div class="input-field">
        <label for="planName"> اسم المخطط </label>
        <select id="planName" (change)="onPlanNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of planNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>


    <div style="overflow-y: scroll; height: 40vh;">
        <div class="input-field">
          <label for="parcelPlan">رسم المخطط</label>
          <input type="text" id="parcelPlan" [(ngModel)]="parcelPlan">
         </div>
  
         <div class="input-field">
          <label for="parcelAsbuilt">رسم الطبيعة</label>
          <input type="text" id="parcelAsbuilt" [(ngModel)]="parcelAsbuilt">
         </div>
  
         <div class="input-field">
          <label for="MAPhotographyZone">مرحلة العمل بالتصوير الجوي</label>
          <input type="text" id="MAPhotographyZone" [(ngModel)]="MAPhotographyZone">
         </div>
  
         <div class="input-field">
          <label for="planCorrect">مرحلة تصحيح المخطط</label>
          <input type="text" id="planCorrect" [(ngModel)]="planCorrect">
         </div>
  
         <div class="input-field">
          <label for="zoneCode">تقسيم النطاقات</label>
          <input type="text" id="zoneCode" [(ngModel)]="zoneCode">
         </div>
  
         <div class="input-field">
          <label for="comparison">المطابقة</label>
          <input type="text" id="comparison" [(ngModel)]="comparison">
         </div>
  
         <div class="input-field">
          <label for="balady2">بلدي 2</label>
          <input type="text" id="balady2" [(ngModel)]="balady2">
         </div>
  
         <div class="input-field">
          <label for="F3D">الرسم ثلاثي الأبعاد</label>
          <input type="text" id="F3D" [(ngModel)]="F3D">
         </div>
  
         <div class="input-field">
            <label for="parcelCount">عدد القطع بالمخطط</label>
            <input type="text" id="parcelCount" [(ngModel)]="parcelCount">
           </div>

           <div class="input-field">
            <label for="parcelArea">مساحة القطع</label>
            <input type="text" id="parcelArea" [(ngModel)]="parcelArea">
           </div>
    </div>
    <!-- <input type="file" name="file"  id="file"> -->

    <button class="btn btn-primary" (click)="savePlanDetails()">save</button>
</div>